import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ customerReference1Error: string }>;

export const DispatchcustomerReference1Error: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/CustomerReference1Error",
        customerReference1Error: props.parameter.customerReference1Error,
    });
};

export const chain = [DispatchcustomerReference1Error];

const setCustomerReference1Error = createHandlerChainRunner(chain, "customerReference1Error");
export default setCustomerReference1Error;
